import { Component, input } from '@angular/core';
import { ProposalShortlistItem } from '../../models/mercer-support-incumbent-member.model';

@Component({
  selector: 'customer-positions-overlay',
  templateUrl: './positions-overlay.component.html',
  styleUrls: ['./positions-overlay.component.scss'],
  standalone: false
})
export class PositionsOverlayComponent {
  readonly finalIncumbentPositions = input<ProposalShortlistItem[] | undefined>(undefined);
  readonly shortlistedOnOpenPositions = input<ProposalShortlistItem[] | undefined>(undefined);
  readonly shortlistedOnClosedPositions = input<ProposalShortlistItem[] | undefined>(undefined);
}
